export default {
  listaGrupos: [],
  grupo: {
    id: null,
    nome: '',
    ativo: true,
  },
}
